import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

import { colors } from '../../theme/palette';

export const Plus = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ sx, ...props }, ref) => (
    <SvgIcon
      viewBox="0 0 16 16"
      {...props}
      sx={{ fill: 'none', fontSize: '1rem', ...(sx || {}) }}
      ref={ref}
    >
      <rect width="16" height="16" rx="4" fill={colors.richBlack} />
      <rect x="2" y="7" width="12" height="2" rx="1" fill="white" />
      <rect
        x="5.97327"
        y="13.7352"
        width="12"
        height="2"
        rx="1"
        transform="rotate(-80 5.97327 13.7352)"
        fill="white"
      />
    </SvgIcon>
  )
);

Plus.displayName = 'Plus';
